import { getContext } from '@fiverr-private/fiverr_context';
import favicon from './static/favicon.ico';
import proFavicon from './static/pro-favicon.ico';
import faviconActive from './static/favicon-active.ico';
import proFaviconActive from './static/pro-active-favicon.ico';

interface Experience {
    isBusiness?: boolean;
}

function decorate(): void {
    const { experience } = getContext() as { experience?: Experience };
    const isBusiness = Boolean(experience?.isBusiness);

    const path = isBusiness ? proFaviconActive : faviconActive;
    setFavicon(path);
}

function reset(): void {
    const { experience } = getContext() as { experience?: Experience };
    const isBusiness = Boolean(experience?.isBusiness);

    const path = isBusiness ? proFavicon : favicon;
    setFavicon(path);
}

function setFavicon(path: string): void {
    const favicon = document.querySelector('link[rel="shortcut icon"]');

    if (!favicon) {
        return;
    }

    favicon.setAttribute('href', path);
}

export const FaviconController = {
    decorate,
    reset,
};
